import { setCartArticleList, setCartSale } from "../modules/cart";
import Immutable from "immutable";

const clearCart = () => (dispatch, getState) => {
  return Promise.all([dispatch(setCartSale(null)), dispatch(setCartArticleList(Immutable.List()))]);
};

export default clearCart;



// WEBPACK FOOTER //
// ./src/app/redux/actions/clearCart.js